import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "50px",
    marginBottom: "100px",
  },
  container: {
    padding: "10px",
    borderRadius: "5px",
    position: "relative",
    zIndex: 1,
    marginTop: -25,
  },
  liquidPrimary: {
    fontSize: "12px",
    display: "flex",
  },
  liquidSecondary: {
    fontSize: "11px",
  },
  gridIcon: {
    flexBasis: "10%",
    marginRight: 4,
  },
  grid: {
    cursor: "pointer",
  },
}));
export default useStyles;
